import { ROLE_TYPE } from '~/app/constants';

export const SSO_PRE_AUTH_TOKEN_KEY = 'sso_pre_auth_token';
export const SSO_MFA_REASON = 'mfa-not-satisfied';

// Mirrors the `reason` query param values HandleSSOInitiate/HandleSSOCallback redirect with (auth/sso.go).
export const SSO_NO_ACCOUNT_COPY_BY_REASON = {
  'invalid-state': {
    mainText: 'Your sign-in session could not be verified',
    subText:
      'Your sign-in link may have expired or already been used. Please return to the login page and try again.',
  },
  'auth-error': {
    mainText: 'Sign-in was not completed',
    subText:
      'Your identity provider did not complete the sign-in process. Please try again, or contact your administrator if this continues.',
  },
  'token-exchange-failed': {
    mainText: "We couldn't complete your sign-in",
    subText:
      'There was a problem communicating with your identity provider. Please try again in a moment.',
  },
  'identity-parse-failed': {
    mainText: "We couldn't verify your identity",
    subText:
      'Your identity provider did not return the information we need to sign you in. Please contact your administrator.',
  },
  'lookup-error': {
    mainText: "We couldn't check your account",
    subText:
      'A temporary error occurred while looking up your account. Please try again in a moment.',
  },
  'provider-not-configured': {
    mainText: "Your organization isn't set up for single sign-on yet",
    subText:
      'Contact your administrator to have your identity provider configured for this application.',
  },
  'token-issue-failed': {
    mainText: "We couldn't start your session",
    subText: 'A temporary error occurred while preparing your sign-in. Please try again.',
  },
  'email-sync-lookup-error': {
    mainText: "We couldn't check your account",
    subText:
      'A temporary error occurred while looking up your account. Please try again in a moment.',
  },
  'no-active-logins-by-email': {
    mainText: 'Your user login has not been provisioned',
    subText:
      'No active account was found for your email address. Contact your administrator to request access.',
  },
  'post-sync-lookup-error': {
    mainText: "We couldn't check your account",
    subText:
      'A temporary error occurred while looking up your account. Please try again in a moment.',
  },
  'sync-created-no-active-mappings': {
    mainText: 'Your user login has not been provisioned',
    subText:
      'Your email address does not match any active account. Contact your administrator to request access.',
  },
  'email-claim-missing': {
    mainText: "We couldn't verify your identity",
    subText:
      'Your identity provider did not share an email address with us, so we could not match you to an account. Please contact your administrator.',
  },
};

// Fallback for a missing/unrecognized reason (e.g. no CLO login mapped to the SSO identity).
export const SSO_NO_ACCOUNT_DEFAULT_COPY = {
  mainText: 'Your user login has not been provisioned',
  subText: 'Contact your administrator to request access to this application.',
};

export const SSO_COLUMNS = [
  { key: 'name', label: 'Username' },
  { key: 'role', label: 'Role' },
  { key: 'office', label: 'Office / Company' },
  { key: 'user_id', label: 'User ID' },
  { key: 'account_code', label: 'Account Code' },
  { key: 'efin', label: 'EFIN' },
  { key: 'last_used', label: 'Last Used' },
];

export const SSO_ACCOUNT_PAGE_SIZE_OPTIONS = [10, 14, 25, 50];

export const SSO_DETAIL_TEMPLATES = {
  efinPreparer: [
    { label: 'User ID', field: 'user_id' },
    { label: 'Account Code', field: 'account_code' },
    { label: 'EFIN', field: 'efin' },
  ],
  resellerMultiOffice: [
    { label: 'User ID', field: 'user_id' },
    { label: 'Account Code', field: 'account_code' },
  ],
};

export const SSO_ROLE_BUNDLE = {
  SUPERUSER: 'superUser',
  RESELLER_MULTIOFFICE: 'resellerMultiOffice',
  EFIN_PREPARER: 'efinPreparer',
  TECH_SUPPORT: 'techSupport',
};

export const SSO_LOGIN_TYPE_LABELS = {
  [ROLE_TYPE.SUPERUSER]: 'Superuser',
  [ROLE_TYPE.RESELLER]: 'Reseller',
  [ROLE_TYPE.MULTIOFFICE]: 'Multioffice',
  [ROLE_TYPE.EFIN]: 'EFIN',
  [ROLE_TYPE.PREPARER]: 'Preparer',
  [ROLE_TYPE.TECH_SUPPORT]: 'Tech Support',
  [ROLE_TYPE.TECH_SUPPORT_SBA]: 'Tech Support SBA',
};

export const SSO_NON_EXPANDABLE_ROLE_TYPES = [
  ROLE_TYPE.SUPERUSER,
  ROLE_TYPE.TECH_SUPPORT,
  ROLE_TYPE.TECH_SUPPORT_SBA,
];
